// Mock data for Momshiach landing page

export const testimonials = [
  {
    id: 1,
    name: "Batsheva N.",
    location: "",
    text: "After working with Chanah, I noticed a real sense of calm and balance in my day to day life. Her approach is gentle and intuitive, and the session left me feeling clearer and more centered. It's a subtle but meaningful shift that's made a difference for me.",
    rating: 5
  },
  {
    id: 2,
    name: "Nechama Dukes",
    location: "",
    text: "You made it very simple. Sometimes it's so complicated in our heads, but it's not really complicated at all. I'm less worried, and more content, I'm not worried. It feels like ME.",
    rating: 5
  },
  {
    id: 3,
    name: "Batya R.",
    location: "",
    text: "Chanah has helped me tremendously in moving past mental and emotional blockages, unhealthy thought and behavioral patterns which I have been holding on to for many years, some of them for a lifetime.",
    rating: 5
  },
  {
    id: 4,
    name: "C.K.",
    location: "",
    text: "Chanah's heart hears and sees in a way that just 'gets it'. With a presence so available and super open to flow with you wherever it is you're going. So grateful to meet this gift along my journey!",
    rating: 5
  },
  {
    id: 5,
    name: "S.W.",
    location: "",
    text: "Chanah has a special way of making you feel seen and supported with gentleness and an emotional intuitiveness that is rare to find! Her deep care is felt immediately and her wisdom and life experience are extremely beneficial as a client.",
    rating: 5
  }
];

export const services = [
  {
    id: 1,
    name: "EFT Tapping",
    description: "Emotional Freedom Technique to release emotional blockages through meridian tapping points."
  },
  {
    id: 2,
    name: "Narrative Therapy",
    description: "Reframe your life story and create new, empowering narratives that align with your true self."
  },
  {
    id: 3,
    name: "Integrative Nutrition Health Coaching",
    description: "Holistic approach to wellness through mindful nutrition and lifestyle changes."
  },
  {
    id: 4,
    name: "Plant Based Cooking Demonstrations",
    description: "Learn to prepare simple, mostly plant-based meals that nourish body and soul."
  },
  {
    id: 5,
    name: "Personal Growth Retreat",
    description: "Immersive experience for deep healing and spiritual transformation."
  }
];

export const benefits = [
  {
    id: 1,
    title: "No Time Commitment",
    description: "Sessions happen remotely while you go about your day. No Zoom calls, no blocked calendar - just passive healing that fits your busy life."
  },
  {
    id: 2,
    title: "Therapy for Kids — Without the Fight",
    description: "Because the client doesn't need to be present, this is a gentle way for parents to help their kids heal without battles, resistance, or sit-down therapy sessions. You arrange it; they receive the benefits."
  },
  {
    id: 3,
    title: "Release Emotional Trauma",
    description: "Gently uncover and heal the places where your soul has been carrying weight that was never meant to be held."
  },
  {
    id: 4,
    title: "Reduce Stress & Anxiety",
    description: "Clear energetic blockages stemming from trauma, stress, or negative patterns to restore inner balance."
  },
  {
    id: 5,
    title: "Reconnect with Yourself",
    description: "Come back to your authentic self and rediscover your energy, clarity, and sense of purpose as a mother."
  },
  {
    id: 6,
    title: "Improve Physical Health",
    description: "When energy flows freely, the body naturally returns to a state of harmony and vitality."
  },
  {
    id: 7,
    title: "Deepen Spiritual Connection",
    description: "Return to clarity, vitality, and simcha through gentle tikun rooted in awareness and Divine Connection."
  }
];

export const resourceData = {
  book: {
    id: "nourish-yourself-first",
    title: "Nourish Yourself First",
    subtitle: "A Plant-Forward Guide to Building Healthy Habits — One Simple Step at a Time",
    coverUrl: "https://drive.google.com/thumbnail?id=19opov90XYcqrTi8P-Wfvbi-lFvIqmvID&sz=w1200",
    price: "$14.99",
    coachCredit: "Created by an Integrative Nutrition Health Coach",
    story: [
      "You've spent years caring for everyone else.",
      "Making sure your family is fed.",
      "Keeping up with responsibilities.",
      "Showing up every day.",
      "But somewhere along the way, your own health may have moved to the bottom of the list.",
    ],
    pullQuote: "This book was created to help you come back to yourself.",
    approachNot: [
      "another restrictive diet",
      "complicated meal plans",
      "trying to change everything overnight",
    ],
    approachYes:
      "But through simple, sustainable habits that nourish your body and fit into real life.",
    coachIntro:
      "As an Integrative Nutrition Health Coach, I believe that lasting wellness comes from understanding your body, creating supportive routines, and taking small steps that build confidence over time.",
    coachIntro2:
      "This book guides you through a plant-forward approach to healthy living — helping you incorporate more wholesome, nourishing foods into your life in a way that feels simple, enjoyable, and sustainable.",
    personas: [
      "A busy mom who wants to prioritize her own health again.",
      "Someone completely new to healthy cooking.",
      "A person told by your doctor to eat more plant-based foods but doesn't know where to begin.",
      "Someone looking for a more intentional way to nourish your body.",
    ],
    personasClosing: "You will find a clear, approachable path forward.",
    differenceTitle: "Why This Book Is Different",
    differenceIntro: "This isn't just a collection of recipes. It's a foundation for a healthier lifestyle. Inside, you'll learn:",
    differenceItems: [
      "Simple, beginner-friendly ways to prepare nourishing meals",
      "How to create healthy kitchen habits that last",
      "How to add more plant-forward foods without feeling restricted",
      "How small daily choices can create meaningful change",
      "How to build confidence in the kitchen — even if healthy cooking feels unfamiliar",
    ],
    torahQuote:
      "Judaism teaches us that our bodies are a gift from Hashem and that caring for ourselves is part of our responsibility. The way we care for ourselves impacts not only our own well-being, but also the example we create for those around us.",
    torahClosing: "Our children learn from what they see. When they see us choosing nourishment, balance, and self-care, they absorb those values too.",
    samplePages: [
      { id: "1VXWejZOKl-aqqn3UNaIOrBPCJb9GxKx_", alt: "Recipe page from Nourish Yourself First — sample 1" },
      { id: "10xI9h2SKHd-uYP7F2ilM2mM0ylwkOtH1", alt: "Recipe page from Nourish Yourself First — sample 2" },
      { id: "1qjOQc6gSRjH6T0gjR4WDyXpfnUSTXIYO", alt: "Recipe page from Nourish Yourself First — sample 3" },
    ],
    testimonials: [
      { name: "Orah S.F.", quote: "Received your cookbook and it has exceeded expectations! It is outstanding and brilliant!! Thanks so much 🌺" },
      { name: "Steph T.", quote: "From someone who has shelves and shelves of cookbooks — I specifically love this one 🩵" },
      { name: "Yehudit", quote: "I came to Israel looking for a hobby. I purchased your cookbook and it became my companion throughout the summer." },
      { name: "Bina", quote: "This is more than just a cookbook, it's an experience." },
    ],
    closing: [
      "Healthy living doesn't start with perfection.",
      "It starts with one choice.",
      "One nourishing meal.",
      "One healthy habit at a time.",
    ],
    closingCta: "Begin your journey toward a healthier, more intentional life today.",
    buyUrl: "https://www.amazon.com/Return-Your-Roots-Non-Cook-Cookbook/dp/B0CPM7BFGH/",
    buyCta: "Buy the Book on Amazon — $14.99",
    companion: {
      title: "Want Extra Guidance?",
      leadIn: "For those who enjoy learning visually, an optional companion video tutorial series is available separately.",
      desc: "These step-by-step videos allow you to cook alongside me, see techniques demonstrated in real time, and gain additional confidence as you build your healthy habits.",
      framing: "The book provides the complete foundation. The videos are an added resource for those who want extra support and hands-on guidance.",
      url: "https://nas.com/momshiach/digital-files/return-to-your-roots-video-page-companion",
      cta: "Add the Video Companion",
    },
  },
  courses: [
    {
      id: "fridge-magic",
      title: "Fridge Magic: Master Healthy Eating for Life",
      price: "₪220",
      desc: "Learn how to stock, prep, and use your kitchen in a way that actually supports your energy, your family, and your real life.",
      cta: "Start Course",
      url: "https://nas.com/momshiach/courses/fridge-magic-master-healthy-eating-for-life",
    },
    {
      id: "turnkey-cafe",
      title: "Turnkey Home Cafe",
      price: null,
      desc: "Create a beautiful, functional, and nourishing kitchen experience that feels elevated—but doable.",
      cta: "Explore Course",
      url: "https://www.skool.com/momshiach-8971/about",
    },
  ],
  membership: {
    id: "community",
    title: "Join the Momshiach Community",
    price: "$26 / month",
    desc: "A living, breathing space for ongoing support, learning, and connection.",
    includes: [
      "5-part video series (Return To Your Roots)",
      "Ingredients & equipment guide",
      "Fridge setup",
      "Meal prep foundations",
      "Ongoing video tutorials",
      "Interactive online community",
      "Direct access to Chanah / Chef Raw Raw / Momshiach",
    ],
    positioning: "Not just a course — this is your ongoing support system.",
    cta: "Join the Community",
    url: "https://www.skool.com/cook-the-bookclub-9762/classroom",
  },
  digitalFiles: [
    {
      id: "wartime-sanity",
      title: "Wartime Sanity: Back to the Basics in the Kitchen",
      desc: "A grounding, back-to-basics guide for feeding yourself and your family during overwhelming seasons.",
      cta: "Download Now",
      url: "https://nas.com/momshiach/digital-files/wartime-sanity-back-to-the-basics",
    },
    {
      id: "raw-raw-workbook",
      title: "Chef Raw Raw Masterclass Workbook",
      desc: "Build confidence and structure in your kitchen.",
      cta: "Get Workbook",
      url: "https://nas.com/momshiach/products/chef-raw-raw-masterclass-workbook",
    },
    {
      id: "rediscovering-you",
      title: "Rediscovering You: An Intrapersonal Workbook",
      desc: "Reconnect to yourself, your needs, and your inner voice.",
      cta: "Start Now",
      url: "https://nas.com/momshiach/products/rediscovering-you-an-intrapersonal-workbook",
    },
  ],
  freeChallenge: {
    id: "7-day-challenge",
    title: "Adding Healthy Habits to Your Week — 7 Day Challenge",
    desc: "A simple, realistic way to start showing up for yourself — without overwhelm.",
    cta: "Join Free Challenge",
    url: "https://nas.com/momshiach/challenges/adding-more-veggies-to-your-week",
  },
};
